import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import BasicBadge from "../../components/BasicBadge";
import {DataTableExProps} from "../../components/dataTable/models";
import {Aziende} from "@commons/mapping/DataTablesSchema";
import React, {useState} from "react";
import {useDeviceSelectors} from "react-device-detect";
import DTTitle from "../../components/dataTable/TableTitle";
import DTTable from "../../components/dataTable/Table";
import Pagination from "../../components/dataTable/Pagination";
import * as Buttons from "../../components/dataTable/buttons";

const BadgeIsStarting = () => <BasicBadge type={"warning"} label="In apertura"/>;
const BadgeActive = () => <BasicBadge type={"success"} label="Attiva"/>;
const BadgeHasEnded = () => <BasicBadge type={"danger"} label="CESSATA"/>;

interface ElencoAziendeProps extends DataTableExProps<Aziende> {
    selezionaAzienda: (idAzienda: number, idAziendaMaster: number) => void;
}

const ElencoAziende: React.FC<ElencoAziendeProps> = (props) => {
    const {dataTables, selezionaAzienda} = props;
    const [selectors, data] = useDeviceSelectors(window.navigator.userAgent)
    const {isMobile, mobileVendor} = selectors;
    const [currentRow, setCurrentRow] = useState<number | null>(null);
    const recordsFiltered = dataTables ? dataTables.recordsFiltered : 0;

    return (<>
        {dataTables && <>
            {/*<p>Num. aziende: {recordsFiltered}</p>*/}
            <div> {/*className="px-4 sm:px-6 lg:px-8">*/}

                {/* Titolo tabella, combo selezione righe per pagina, ricerca... */}
                <DTTitle id="elencoAziende" {...props}
                         title="Elenco aziende"
                         subTitle={`Elenco delle aziende sulla base dell'ultima ricerca effettuata! Sono state trovate ${recordsFiltered} aziende.`}/>

                {/* Sviluppo tabella vera e propria! */}
                <DTTable<AziendaRecord> dtSchema={dataTables}
                                        header={<>
                                            <th scope="col" className="tableTH">
                                                Cod.Azienda/UL
                                            </th>
                                            <th scope="col" className="tableTH">
                                                Denominazione Azienda
                                            </th>
                                            <th scope="col" className="tableTH">
                                                {'Descrizione Unità Locale'}
                                            </th>
                                            <th scope="col" className="w-14"/>
                                        </>}

                                        rows={({item, index, isMobile, currentRow, register}) => {
                                            const {key, ...rest} = register(item.idAzienda, index, false);
                                            return <tr key={key} {...rest}>
                                                <td className="tableTD">
                                                    {item.codAzienda}/{item.codFiliale}&nbsp;{AziendaRecord.isStarting(item) && <BadgeIsStarting/>}{AziendaRecord.hasEnded(item) &&
                                                    <BadgeHasEnded/>}
                                                </td>

                                                <td className="tableTD">
                                                    {item.denominazione}
                                                </td>

                                                <td className="tableTD">{item.unitaLocale}</td>

                                                <td className="text-sm font-medium">
                                                    <Buttons.Visibility visible={isMobile || index === currentRow}>
                                                        <Buttons.GO onAction={() => selezionaAzienda(item.idAzienda, item.idAziendaMaster)}/>
                                                    </Buttons.Visibility>
                                                </td>
                                            </tr>
                                        }
                                        }
                />
                {/*Paginazione*/}
                <Pagination {...props}></Pagination>
            </div>
        </>}
    </>)
}
export default ElencoAziende;